<template>
  <div class="mt-2 mb-4">
    <v-list-subheader class="mb-4 mt-0">
      <span class="my-referral-detail-section-header">Details</span>
    </v-list-subheader>
    <!-- Stats Section -->
    <v-row no-gutters>
      <v-col cols="6" class="pl-4">
        <v-row>
          <v-col>
            <div>Date Ingested</div>
            <div class="text-h6 font-weight-medium">
              {{ dateIngested }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div>Type</div>
            <div class="text-h6 font-weight-medium">
              {{ type }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div>Lead Status</div>
            <div class="text-h6 font-weight-medium">
              {{ status }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div>Lead Source</div>
            <div class="text-h6 font-weight-medium">
              {{ leadSource }}
            </div>
          </v-col>
        </v-row>
      </v-col>
      <!-- Agent Info -->
      <v-col cols="6" class="pr-4">
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              v-model="localFirst"
              label="first name"
              variant="underlined"
              color="primary"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="localLast"
              label="last name"
              variant="underlined"
              color="primary"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="localPhone"
              :mask="phoneMask"
              label="phone number"
              variant="underlined"
              color="primary"
              type="tel"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="localEmail"
              label="email address"
              variant="underlined"
              color="primary"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-snackbar
      v-bind="alert"
      :color="alertColor"
      :multi-line="alertMultiline"
      top
    >
      {{ alertText }}
    </v-snackbar>
  </div>
</template>

<script>
//import { authMixin } from "@/mixins/auth";
//import { formatters } from "@/mixins/formatters";
import useAuthMixin from "@/mixins/auth";
import useFormatters from "@/mixins/formatters";

const testEmailExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
  name: "MyLeadDetailDetails",
  // mixins: [authMixin, formatters],
  props: {
    lead: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      localLead: null,
      localFirst: "",
      snapshotFirst: "",
      localLast: "",
      snapshotLast: "",
      localEmail: "",
      snapshotEmail: "",
      localPhone: "",
      snapshotPhone: "",
      phoneMask: "(###) ###-####",
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length <= 255 || "Name must be less than 255 characters",
      ],
      phoneRules: [
        (v) => !!v || "Phone number is required",
        (v) => v.length !== 13 || "Phone number must be 10 numbers.",
      ],
      emailRules: [
        (v) => !!v || "Email address is required",
        (v) => testEmailExp.test(v) || "Invalid e-mail.",
      ],
      alert: false,
      alertText: "",
      alertColor: "success",
      alertMultiline: false,
    };
  },
  watch: {
    lead() {
      console.log("lead changed");

      this.localLead = { ...this.lead };
      this.loadLeadData();
    },
  },
  computed: {
    dateIngested() {
      if (this.lead && this.lead.created) {
        return this.formatDate(this.lead.created);
      }

      return "-";
    },
    type() {
      if (
        this.lead &&
        this.lead.opportunity &&
        this.lead.opportunity.clientType
      ) {
        return this.prettyPrintEnum(this.lead.opportunity.clientType);
      }

      return "-";
    },
    sourceOfLead() {
      return "N/A";
    },
    status() {
      if (this.lead && this.lead.opportunity && this.lead.opportunity.status) {
        return this.prettyPrintEnum(this.lead.opportunity.status);
      }

      return "-";
    },
    leadSource() {
      if (
        this.lead &&
        this.lead.opportunity &&
        this.lead.opportunity.cleanReferringWebsite
      ) {
        return this.lead.opportunity.cleanReferringWebsite;
      }

      return "-";
    },
  },
  methods: {
    ...useAuthMixin(),
    ...useFormatters(),
    loadLeadData() {
      this.localFirst = "";
      if (this.lead && this.lead.contact && this.lead.contact.nameFirst) {
        this.localFirst = this.lead.contact.nameFirst;
      }

      this.localLast = "";
      if (this.lead && this.lead.contact && this.lead.contact.nameLast) {
        this.localLast = this.lead.contact.nameLast;
      }

      this.localPhone = "";
      if (this.lead && this.lead.contact && this.lead.contact.phoneNumber) {
        this.localPhone = this.formatPhoneNumber(this.lead.contact.phoneNumber);
      }

      this.localEmail = "";
      if (this.lead && this.lead.contact && this.lead.contact.emailAddress) {
        this.localEmail = this.lead.contact.emailAddress;
      }
    },
  },
  mounted() {
    this.loadLeadData();
  },
};
</script>

<style scoped>
.codeTitle {
  font-size: 1.15em;
}
.my-referral-detail-section-header {
  color: #484848 !important;
  font-size: 24px;
  margin-bottom: 0;
  margin-top: 16px;
  font-weight: 500;
}
</style>
